import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import Balaclava from 'cityads-v3/components/Balaclava';

import {
  USER_ROLE_CODE_WEBMASTER,
} from 'cityads-v3/reducers/auth';

import SwaggerWrapper from './SwaggerWrapper';
import { RootState } from 'cityads-v3/types/reducer';

export default function SwaggerPage(): JSX.Element {
  const { t } = useTranslation(['Publisher'])
  const language = useSelector((state: RootState) => state.language.language)
  const userRoleCode = useSelector((state: RootState) => state.auth.user?.user_role_code)
  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn)

  const showBacklink = isLoggedIn && userRoleCode === USER_ROLE_CODE_WEBMASTER;

  return (
    <>
      <Helmet>
        <title>{t('api.description')}</title>
      </Helmet>

      <Balaclava
        title={t('api.description')}
        backlink={showBacklink ? '/publisher/api' : null}
        backlinkText={showBacklink ? t('api.api') : null}
      />

      <SwaggerWrapper language={language} />
    </>
  )
}
